<template>
  <div>
    <div class="top-box">
      <span>{{$t('businessCop')}}</span>
    </div>
    <div>
      <p>{{$t('contactUs')}}</p>
      <el-form ref="form" :model="formData" :rules="rules" class="form-box">
        <el-form-item prop="name">
          <el-input  v-model="formData.name" class="input-line" :placeholder="$t('name')"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="formData.phone" class="input-line" :placeholder="$t('phone')"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="formData.email" class="input-line" :placeholder="$t('email')"></el-input>
        </el-form-item>
        <el-form-item prop="content">
          <el-input class="input-area" type="textarea"
                    v-model="formData.content" 
                    :autosize="{ minRows: 5, maxRows: 6}"
                    :placeholder="$t('requirement')"></el-input>
        </el-form-item>

        <el-button class="submitBtn" type="primary" @click="submitForm">{{$t('submit')}}</el-button>
      </el-form>
    </div>
    <fix-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer';

export default {

  data(){
    return{
      formData: {
        name: '',
        phone: '',
        email: '',
        content: ''
      },
      rules: {
        name: [
          {required: true, trigger: 'blur'},
        ],
        phone: [
          {required: true, trigger: 'blur'},
        ],
        email: [
          {required: true, trigger: 'blur'},
        ],
      },
    }
  },

  methods: {
    submitForm(){

      this.$refs['form'].validate((valid) => {
          if (valid) {
            const formObj = {
              "e441de429e6c11ea92d821e1c07b07e9": this.formData.name,
              "689e48309e7411ea91d1693e376dee92": this.formData.phone,
              "70279a729e7411ea91d1693e376dee92": this.formData.email,
              "72ed23009e7411ea91d1693e376dee92": this.formData.content
            };
            const formStr = JSON.stringify(formObj);

            var urlencoded = new URLSearchParams();
            urlencoded.append('formData', formStr);
            urlencoded.append('formId', '5ecb948787e28b00016f7ed6');

            fetch('https://www.biaodanhui.com/form/api/form/data', {
              method: 'POST',
              headers: {
                'Content-Type': "application/x-www-form-urlencoded"
              },
              body: urlencoded
            }).then(response => {
              console.log(response);
              this.$message({
                message: '恭喜您提交成功！',
                type: 'success',
                offset: 180
              });
            });

            this.formData = {};

          } else {

            this.$message({
              message: '请输入完整信息',
              type: 'warning',
              offset: 180
            });
            return false;
          }
      });

    },
  },
  
  components: {
    'fix-footer': Footer,
  }
}
</script>

<style lang="less" scoped>

.top-box{
  background: url('../assets/business_bg.png') no-repeat center center;
  background-size: 100% 100%;
  height: 340px; /*px*/

  span{
    color: #fff;
    font-size: 50px; /*px*/
    display: block;
    line-height: 320px;/*px*/
    text-align: left;
    margin-left: 140px;
  }
}

p{
  margin: 60px auto;
  font-size: 40px;  /*px*/
}

.form-box{
  /deep/ .el-form-item__error{
    display: none;
    // color: #ffffff;
  }
}

.input-line{
  /deep/ input{
    width: 800px; /*px*/
    height: 100px; /*px*/
    border-radius:50px;/*px*/
    font-size: 25px;/*px*/
    padding-left: 30px;
    margin-bottom: 20px;
  }
}

.input-area{
  /deep/ textarea{
    width: 800px; /*px*/
    height: 300px; /*px*/
    border-radius:30px;/*px*/
    margin: 0 auto;
    font-size: 25px;/*px*/
    padding-left: 30px;
    margin-bottom: 20px;
  }
}

.submitBtn{
  width: 800px; /*px*/
  height: 100px; /*px*/
  border-radius:35px;/*px*/
  margin-bottom: 60px;
  margin-top: 10px;
  font-size: 25px;/*px*/
}

</style>


// WEBPACK FOOTER //
// src/pages/Business.vue